import { IoTrophy, IoFlame, IoStar, IoBook, IoCheckmarkCircle, IoPeople } from 'react-icons/io5';
import './ReaderStatsCard.css';

const ReaderStatsCard = ({
  reader,
  profile,
  derived = {},
  competitiveMode = false,
  onRefresh
}) => {
  if (!profile && derived.readingDays == null) {
    return (
      <div className="reader-stats-card loading">
        <div className="stats-loading">
          <div className="loading-spinner"></div>
          <p>Loading stats...</p>
        </div>
      </div>
    );
  }

  const { points, level, stats } = profile || {};
  const streak = stats?.currentStreak ?? 0;
  const booksFinished = derived.booksFinished ?? 0;
  const booksTotal = derived.booksTotal ?? 66;
  const challengeChapters = derived.challengeChapters;
  const communityContributions =
    derived.communityContributions ?? stats?.uniqueChaptersRead ?? 0;
  const hasChallengeWindow = challengeChapters != null;

  const statItems = [
    {
      icon: IoFlame,
      label: derived.readingDays != null ? 'Days participated' : 'Streak',
      value: derived.readingDays ?? streak,
      color: '#F97316',
      subtitle: derived.readingDays != null ? 'days with reading in this view' : (streak === 1 ? 'day in a row' : 'days in a row')
    },
    {
      icon: IoBook,
      label: 'Books finished',
      value: `${booksFinished} of ${booksTotal}`,
      color: '#10B981',
      subtitle: 'of the Protestant canon'
    },
    {
      icon: IoCheckmarkCircle,
      label: derived.chaptersRead != null ? 'Chapters read' : 'Chapters this challenge',
      value: derived.chaptersRead ?? (hasChallengeWindow ? challengeChapters : '—'),
      color: '#3B82F6',
      subtitle: derived.chaptersRead != null ? 'including rereads' : (hasChallengeWindow ? 'logged in this season' : 'no challenge running')
    },
    {
      icon: IoPeople,
      label: 'Community contributions',
      value: communityContributions,
      color: '#8B5CF6',
      subtitle: 'unique chapters logged'
    }
  ];

  if (competitiveMode) {
    statItems.push(
      {
        icon: IoStar,
        label: 'Total points',
        value: points?.totalPoints?.toLocaleString() || '0',
        color: '#F59E0B',
        subtitle: `${points?.lifetimePoints?.toLocaleString() || '0'} lifetime`
      },
      {
        icon: IoTrophy,
        label: 'Current level',
        value: points?.currentLevel || 1,
        color: '#8B5CF6',
        subtitle: level?.title || 'New reader'
      }
    );
  }

  const progressToNext = points?.pointsToNextLevel
    ? ((points.totalPoints / (points.totalPoints + points.pointsToNextLevel)) * 100)
    : 100;

  return (
    <div className="reader-stats-card">
      <div className="stats-header">
        <div className="reader-info">
          <h2>{reader?.name ? `${reader.name}'s progress` : 'Your progress'}</h2>
          {competitiveMode && (
            <div className="level-badge" style={{ backgroundColor: level?.color || '#6B7280' }}>
              Level {points?.currentLevel || 1}
            </div>
          )}
        </div>
        {onRefresh && (
          <button onClick={onRefresh} className="refresh-button" title="Refresh stats">
            🔄
          </button>
        )}
      </div>

      <div className={`stats-grid ${competitiveMode ? 'stats-grid--competitive' : ''}`}>
        {statItems.map((item) => (
          <div key={item.label} className="stat-item">
            <div className="stat-icon" style={{ color: item.color }}>
              <item.icon />
            </div>
            <div className="stat-content">
              <div className="stat-value">{item.value}</div>
              <div className="stat-label">{item.label}</div>
              <div className="stat-subtitle">{item.subtitle}</div>
            </div>
          </div>
        ))}
      </div>

      {competitiveMode && points?.pointsToNextLevel > 0 && (
        <div className="level-progress">
          <div className="progress-header">
            <span>Progress to level {(points.currentLevel || 1) + 1}</span>
            <span className="progress-text">
              {points.pointsToNextLevel.toLocaleString()} points needed
            </span>
          </div>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{
                width: `${progressToNext}%`,
                backgroundColor: level?.color || '#6B7280'
              }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReaderStatsCard;
